module.exports = __webpack_public_path__ + "static/media/playBtn.85c6b78e.svg";